// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./ExpandedUserRoleStyles";
// @otg-one/ui_components/components
import { Button, Typography, Separator } from "../index";
// @otg-one/ui_components/icons
import { Delete, Edit, Plus } from "../../sap_icons";
import { FunctionGoodsReceipt, FunctionPickPack, FunctionInventoryStatus, FunctionInventoryTransfer, FunctionInventoryCounting, FunctionDelivery, Checkmark, ArrowDiagonalLeftBottom } from "../../icons";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// Material UI Core
import Grid from '@mui/material/Grid';
const UserRoleFunction = (props) => {
    const classes = useStyles(props);
    const { children, icon } = props;
    return (React.createElement("div", { className: classes.userRoleFunctionContainer },
        React.createElement("div", { className: classes.userRoleFunction }, icon),
        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 10, color: Color.neutral[100] }, children)));
};
const ExpandedUserRoleHeader = (props) => {
    const classes = useStyles(props);
    const { goodsReceipt, pickAndPack, inventoryStatus, inventoryTransfer, inventoryCounting, delivery } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { item: true, md: 3 }),
        React.createElement(Grid, { item: true, md: 9 },
            React.createElement("div", { className: classes.expandedUserRoleHeader },
                React.createElement(UserRoleFunction, { icon: React.createElement(FunctionGoodsReceipt, null) }, goodsReceipt),
                React.createElement(UserRoleFunction, { icon: React.createElement(FunctionPickPack, null) }, pickAndPack),
                React.createElement(UserRoleFunction, { icon: React.createElement(FunctionInventoryStatus, null) }, inventoryStatus),
                React.createElement(UserRoleFunction, { icon: React.createElement(FunctionInventoryTransfer, null) }, inventoryTransfer),
                React.createElement(UserRoleFunction, { icon: React.createElement(FunctionInventoryCounting, null) }, inventoryCounting),
                React.createElement(UserRoleFunction, { icon: React.createElement(FunctionDelivery, null) }, delivery)))));
};
const ExpandedUserRoleList = (props) => {
    const classes = useStyles(props);
    const { role } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { item: true, md: 1 },
            React.createElement("div", { className: classes.expandedUserRoleListAction },
                React.createElement(Edit, null),
                React.createElement(Delete, { style: { marginLeft: 10 } }))),
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 18, color: Color.neutral[100] }, role.name)),
        React.createElement(Grid, { item: true, md: 9 },
            React.createElement("div", { className: classes.functionStatusContainer },
                React.createElement("div", { className: classes.functionStatus }, role.goodsReceipt ? (React.createElement(Checkmark, null)) : `-`),
                React.createElement("div", { className: classes.functionStatus }, role.pickPack ? (React.createElement(Checkmark, null)) : `-`),
                React.createElement("div", { className: classes.functionStatus }, role.inventoryStatus ? (React.createElement(Checkmark, null)) : `-`),
                React.createElement("div", { className: classes.functionStatus }, role.inventoryTransfer ? (React.createElement(Checkmark, null)) : `-`),
                React.createElement("div", { className: classes.functionStatus }, role.inventoryCounting ? (React.createElement(Checkmark, null)) : `-`),
                React.createElement("div", { className: classes.functionStatus }, role.delivery ? (React.createElement(Checkmark, null)) : `-`)))));
};
export const ExpandedUserRole = (props) => {
    const classes = useStyles(props);
    const { id, roles, onClose, style, userRoles, addNewRole } = props;
    return (React.createElement("div", { id: id, className: classes.expandedUserRoleContainer, style: style },
        React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 20, color: Color.neutral[100] }, userRoles),
        React.createElement("div", { className: classes.expandedUserRoleExpandIcon },
            React.createElement(ArrowDiagonalLeftBottom, { onClick: onClose })),
        React.createElement(Grid, { container: true, style: { flexGrow: 1 }, spacing: 2, alignItems: "center" },
            React.createElement(ExpandedUserRoleHeader, null)),
        React.createElement("div", { className: classes.expandedUserRoleListContainer },
            React.createElement(Grid, { container: true, style: { flexGrow: 1 }, spacing: 2, alignItems: "center" }, roles.map((role, index) => (React.createElement(React.Fragment, { key: `role-${role.name}-${index}` },
                React.createElement(ExpandedUserRoleList, { role: role }),
                React.createElement(Grid, { item: true, md: 12 },
                    React.createElement(Separator, { type: "n200", width: 2 }))))))),
        React.createElement(Button, { color: "white", icon: React.createElement(Plus, null), alignIcon: "left" }, addNewRole)));
};
ExpandedUserRoleHeader.defaultProps = {
    goodsReceipt: 'Goods Receipt',
    pickAndPack: 'Pick & Pack',
    inventoryStatus: 'Inventory Status',
    inventoryTransfer: 'Inventory Transfer',
    inventoryCounting: 'Inventory Counting',
    delivery: 'Delivery'
};
ExpandedUserRole.defaultProps = {
    roles: [
        {
            name: "Admin",
            goodsReceipt: true,
            pickPack: false,
            inventoryStatus: false,
            inventoryTransfer: true,
            inventoryCounting: true,
            delivery: false,
        }
    ],
    onClose: () => { },
    userRoles: 'User Roles',
    addNewRole: 'Add New Role'
};
export default React.memo(ExpandedUserRole);
